import React from 'react';

const BoldTitleInput = ({ field, label }) => {
  return (
    <div className="formulaire-dynamique-main-div form-field-group form-title-container">
      <div className={`formulaire-dynamique-div ${field.texteVertical && 'formulaire-dynamique-label-wrapper'}`}>
        <span className="formulaire-dynamique-span form-title">
          {label}
        </span>
      </div>
    </div>
  );
};

export default BoldTitleInput;

